import { trim } from "@/modules/common";
import { useMateTrait } from "@/stores/mateTrait";

export const initStyle = (
  reqData: PromptJson,
  style?: number,
  customStyle?: { version: number; prompt: string },
  mixStyle?: MixStyle[]
) => {
  if (mixStyle && mixStyle.length > 0) reqData.mixStyle = mixStyle;
  else if (style) reqData.mixStyle = [{ id: style, percent: 1 }];
  if (reqData.isUnlimited && !customStyle?.version) {
    reqData.customStyle = { version: 2, prompt: "" };
  } else reqData.customStyle = customStyle || { version: 0, prompt: "" };
};

export const formatStyle = (reqData: any, target?: any) => {
  const { mixStyle, customStyle, style } = reqData;
  delete reqData.mixStyle;
  delete reqData.style;
  if (customStyle && customStyle.version) {
  } else if (mixStyle && mixStyle.length > 0) {
    if (mixStyle.length === 1) reqData.style = mixStyle[0].id;
    else reqData.mixStyle = mixStyle;
  } else if (style) {
    reqData.style = style;
  }
  if (target) {
    target.style = reqData.style;
    target.mixStyle = reqData.mixStyle;
    target.customStyle = reqData.customStyle;
  }
  if (!reqData.customStyle) reqData.customStyle = undefined;
  return target || reqData;
};

export const removeMedia = (reqData: any) => {
  function removeMedia(data: any) {
    Object.keys(data).forEach((key) => {
      if (key === "media") delete data[key];
      else if (data[key] && typeof data[key] === "object")
        removeMedia(data[key]);
    });
  }
  let t = JSON.parse(JSON.stringify(reqData));
  removeMedia(t);
  return t;
};

export const initStyleWithInitData = (
  style?: number,
  customStyle?: { version: number; prompt: string },
  mixStyle?: MixStyle[]
) => {
  const version = style || mixStyle ? 0 : 1;
  if (!mixStyle) mixStyle = [];
  if (!style) style = 0;
  else if (mixStyle.length === 0) mixStyle.push({ id: style, percent: 1 });
  if (!customStyle) customStyle = { version, prompt: "" };
  return { style, customStyle, mixStyle };
};

const poses = ["stand by stand", "kiss", "hug"];

export const decodePosesFromEnv = (promptJson: PromptJson) => {
  const promptList = promptJson.env.prompt.split(",");
  let hasPoses = false;
  let posesPrompts: string[] = [];
  poses.forEach((pose) => {
    if (promptList.includes(pose)) {
      posesPrompts.push(pose);
      let exp = new RegExp(`${pose}\,\?`);
      promptJson.env.prompt = promptJson.env.prompt.replace(exp, "");
      hasPoses = true;
    }
  });
  if (posesPrompts.length > 0) promptJson.poses = posesPrompts;
  if (!hasPoses && (promptJson.mates?.length || 0) > 0)
    promptJson.poses = [poses[0]];
  return promptJson;
};

export const encodeEnvFromPoses = (promptJson: PromptJson) => {
  const { poses } = promptJson;
  if (poses) {
    let { prompt } = promptJson.env;
    promptJson.env.prompt = prompt
      ? `${trim(prompt, ",")},${poses.join(",")}`
      : poses.join(",");
  }
  return promptJson;
};

export const checkMatesHasGirlOrBoy = (mates: PromptJsonMateTrait[]) => {
  for (const { prompt, id } of mates) {
    if (!prompt.includes("1girl") && !prompt.includes("1boy")) {
      const { name } = useMateTrait().traitMap[id!];
      return name;
    }
  }
};
